import { ImagePlus, Loader2, X } from 'lucide-react';
import { FieldLabel } from './bannerFormBits';
import type { BannerComposer } from './useBannerComposer';

/** The card's optional picture. The preview on the right shows it at its real size. */
export function ImagePicker({ composer }: { composer: BannerComposer }) {
  const { imagePreview, uploading, uploadError, fileInputRef, handleImagePick, clearImage } = composer;
  return (
    <div className="min-w-0">
      <FieldLabel text="Image" hint="JPG, PNG or WebP, up to 5 MB. Optional." />
      {imagePreview ? (
        <div className="flex min-h-[38px] items-center gap-2 rounded-lg border border-gray-200 px-1 py-0.5">
          <img src={imagePreview} alt="Announcement" className="h-8 w-12 rounded object-cover" />
          <span className="min-w-0 flex-1 truncate text-sm text-gray-600">Image added</span>
          <button
            type="button"
            onClick={clearImage}
            aria-label="Remove image"
            title="Remove image"
            className="mr-1 flex h-6 w-6 flex-none items-center justify-center rounded-full text-gray-500 hover:bg-gray-100 hover:text-gray-700"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        </div>
      ) : (
        <label className="flex min-h-[38px] cursor-pointer items-center justify-center gap-1.5 rounded-lg border-2 border-dashed border-gray-300 text-sm text-gray-500 hover:bg-gray-50">
          {uploading ? <Loader2 className="h-4 w-4 animate-spin" /> : <ImagePlus className="h-4 w-4" />}
          {uploading ? 'Uploading…' : 'Add an image'}
          <input
            ref={fileInputRef}
            type="file"
            accept="image/jpeg,image/png,image/webp"
            className="sr-only"
            onChange={(e) => handleImagePick(e.target.files?.[0] ?? null)}
          />
        </label>
      )}
      {uploadError && <p className="mt-1 text-xs text-red-600">{uploadError}</p>}
    </div>
  );
}
